import {
  useCallDetailsCaller,
  useCallDetailsCallee,
} from 'features/call/call-details/hooks';
import { CallDetailsCalleeReconnect } from 'features/call/call-details/components';

export const CallDetailsCalleeReconnectContainer = () => {
  const { caller } = useCallDetailsCaller();
  const { callee } = useCallDetailsCallee();

  return <CallDetailsCalleeReconnect caller={caller} callee={callee} />;
};
